import cookie from 'js-cookie';

import { COUNTRY_COOKIE } from '@app/helpers/localization';

import { PACKAGE_TYPE } from './components/StockMessage';
import type { PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants as MagentoProductVariant } from './hook/__generated__/PricingPageShopProduct';
import type { UpgradeVariants } from './hook/useUpgradePaths';
import jpStoreLinks from './jp-store-links.json';

export const getProductPrice = (item) =>
  item?.product?.priceRange?.minimumPrice?.finalPrice?.value;

export const getUpgradeVariant = (
  variants: Array<MagentoProductVariant | null> | null,
  upgradeVariants: UpgradeVariants | null | undefined,
) => {
  if (
    (upgradeVariants && Object.keys(upgradeVariants).length === 0) ||
    !variants
  ) {
    return null;
  }

  // TODO: Unit tests for findCheapestUpgrade
  const findCheapestUpgrade = (variants) =>
    variants.reduce((acc, item): MagentoProductVariant | null => {
      const sdbsId = item?.product?.sdbsId;

      if (!sdbsId) {
        return null;
      }

      if (
        upgradeVariants &&
        sdbsId in upgradeVariants &&
        (!acc || (acc && getProductPrice(item) < getProductPrice(acc)))
      ) {
        return item;
      }
      return acc;
    }, null);

  const onlyDLVariants = variants.filter((el) =>
    el?.attributes?.some((a) => a?.adminLabel === PACKAGE_TYPE.DL),
  );
  const onlyBoxVariants = variants.filter((el) =>
    el?.attributes?.some((a) => a?.adminLabel === PACKAGE_TYPE.BOX),
  );

  let upgradeVariant = findCheapestUpgrade(onlyDLVariants);

  if (!upgradeVariant) {
    upgradeVariant = findCheapestUpgrade(onlyBoxVariants);
  }

  return upgradeVariant;
};

export const HW_ITEM_TYPE = 202;
export const HW_SW_ITEM_TYPE = 1318;
export const ACCESSORIES_ITEM_TYPE = 148;
export const CD_DVD_ITEM_TYPE = 389;
export const VINYL_ITEM_TYPE = 157;

export function isJPHardware(product) {
  if (!product) return false;

  return (
    (product?.itemType === HW_ITEM_TYPE ||
      product?.itemType === HW_SW_ITEM_TYPE ||
      product?.itemType === ACCESSORIES_ITEM_TYPE ||
      product?.itemType === CD_DVD_ITEM_TYPE ||
      product?.itemType === VINYL_ITEM_TYPE) &&
    cookie.get(COUNTRY_COOKIE) === 'JP'
  );
}

export function constructJPStoreLink(sku?: string | null) {
  if (!sku) return;

  //@TODO [WWW-12033] Temporary solution until field is implemented in Magento
  const jpStoreLink =
    jpStoreLinks[sku]?.jp_store_link ?? 'https://store.minet.jp/category/_NI/';

  const utmTags =
    '?utm_source=native-instruments.com&utm_medium=referral&utm_campaign=NI+SITE';

  return `${jpStoreLink}${utmTags}`;
}
